export class ApiResponse<T>{
  public data: T;
  public responseMessage: string;
  public isSuccess: boolean;
}
